module.exports = __webpack_public_path__ + "static/p7-9e2a3912d84814983ea5a59e11458317.png";